// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"7bf8798366e49d36","104":"81fd8bb182af9896","619":"06031548e6735efb"}[chunkId] + ".js";
};